export interface PriceInfo {
  current: string
  compareAt: string
  currency: string
  discount: string
}

const PRICE_TABLE: Record<string, PriceInfo> = {
  // Latin America
  CL: {
    current: '15.990',
    compareAt: '43.999',
    currency: 'CLP',
    discount: '-64%',
  },
  AR: {
    current: '23.999',
    compareAt: '70.999',
    currency: 'ARS',
    discount: '-66%',
  },
  CO: {
    current: '63.999',
    compareAt: '189.999',
    currency: 'COP',
    discount: '-66%',
  },
  MX: { current: '299', compareAt: '899', currency: 'MXN', discount: '-67%' },
  UY: { current: '670', compareAt: '1.999', currency: 'UYU', discount: '-67%' },
  PE: {
    current: 'S/ 49',
    compareAt: 'S/ 137',
    currency: 'PEN',
    discount: '-64%',
  },
  CR: {
    current: '₡ 8.390',
    compareAt: '₡ 19.300',
    currency: 'CRC',
    discount: '-57%',
  },
  GT: {
    current: 'Q 80',
    compareAt: 'Q 179',
    currency: 'GTQ',
    discount: '-55%',
  },
  EC: {
    current: '11,90',
    compareAt: '39,99',
    currency: 'USD',
    discount: '-70%',
  },
  VE: {
    current: '12,90',
    compareAt: '39,99',
    currency: 'USD',
    discount: '-68%',
  },
  HN: { current: '399', compareAt: '1.075', currency: 'HNL', discount: '-63%' },
  PY: {
    current: '99.890',
    compareAt: '262.000',
    currency: 'PYG',
    discount: '-62%',
  },
  // North America
  US: {
    current: '17,99',
    compareAt: '49,99',
    currency: 'USD',
    discount: '-64%',
  },
  CA: {
    current: '18,99',
    compareAt: '46,99',
    currency: 'CAD',
    discount: '-60%',
  },
  // Europe
  ES: {
    current: '16,90',
    compareAt: '39,99',
    currency: 'EUR',
    discount: '-58%',
  },
  DE: {
    current: '17,99',
    compareAt: '34,95',
    currency: 'EUR',
    discount: '-49%',
  },
  IT: {
    current: '14,95',
    compareAt: '34,95',
    currency: 'EUR',
    discount: '-57%',
  },
  CH: { current: '17,90', compareAt: '49', currency: 'CHF', discount: '-63%' },
  GB: {
    current: '14,99',
    compareAt: '39,99',
    currency: 'GBP',
    discount: '-63%',
  },
}

const DEFAULT_PRICE: PriceInfo = {
  current: '16,99',
  compareAt: '49,99',
  currency: 'USD',
  discount: '-66%',
}

export function getPriceByCountry(countryCode: string): PriceInfo {
  return PRICE_TABLE[countryCode] ?? DEFAULT_PRICE
}

export { DEFAULT_PRICE }
